<template> 
  <el-empty description=" " :image-size="300"></el-empty>
</template> 